import e from"./HitsPerPage.vue_vue&type=script&lang.js";import{render as t}from"./HitsPerPage.vue_vue&type=template&id=74f3ac28&lang.js";e.render=t,e.__file="src/components/HitsPerPage.vue";export default e;
//# sourceMappingURL=HitsPerPage.vue.js.map
